import { formatCalendarDay } from '@adornis/datetime/calendarDay.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { de } from 'date-fns/locale';
import { html } from 'lit';

/** one Vorgang of the row's bookings: the month it was charged in and how it stands */
export type ProcessMonth = {
  month: Date;
  label: string;
  badgeClass: string;
};

type MemberInlineAccountingEntryMonthsTooltipProps = {
  processes: ProcessMonth[];
};

export const MemberInlineAccountingEntryMonthsTooltip = stateful(
  (props: MemberInlineAccountingEntryMonthsTooltipProps) => {
    // oldest year first, months in order inside it, so the history reads like a calendar
    const byYear = new Map<number, ProcessMonth[]>();
    for (const process of props.processes) {
      const year = process.month.getUTCFullYear();
      byYear.set(year, [...(byYear.get(year) ?? []), process]);
    }
    const years = [...byYear]
      .sort(([yearA], [yearB]) => yearA - yearB)
      .map(([year, processes]) => ({
        year,
        processes: [...processes].sort((a, b) => a.month.getTime() - b.month.getTime()),
      }));
    if (!years.length) return html``;

    return html`
      <div class="text-sm font-semibold text-base-content mb-1">Vorgänge</div>
      <div class="max-w-72 max-h-56 overflow-y-auto pr-1 flex flex-col gap-2">
        ${years.map(
          year => html`
            <div class="flex flex-col gap-1">
              <span class="text-sm font-semibold text-base-content/70">${year.year}</span>
              <div class="flex flex-wrap gap-1">
                ${year.processes.map(
                  process => html`
                    <span class=${`badge badge-sm ${process.badgeClass}`} title=${process.label}>
                      ${formatCalendarDay(process.month, 'dd.MM', { locale: de })} · ${process.label}
                    </span>
                  `,
                )}
              </div>
            </div>
          `,
        )}
      </div>
    `;
  },
);
